import Empty from '../empty/Empty'

import './friend.css'

const Friend = ({data, isFriend}) => {

      if(!isFriend) return 

      return (
            <div className={isFriend ? "pager_content show" : "pager_content"}>
                  <div className="header_page">
                        <span className="bg_grad">Friends</span>
                  </div>
                  <div className="section_page friend">
                        {
                              (!data.data)
                                    ?
                                          data.map((item, index) => (
                                                <div className="card_friend" key={index}>
                                                      <div className="card_friend__inner">
                                                            <img src={item.avatar} alt={item.name} />
                                                            <span className="bg_grad">{item.name}</span>
                                                            <a href={item.me} target="_blank" rel="noreferrer">xat.me</a>
                                                      </div>
                                                </div>
                                          ))
                                    : <Empty text={"Oops!, Not Friends Added"}/>
                        }
                        
                  </div>
            </div>
      )
}

export default Friend
